import { useQuery } from '@tanstack/vue-query'
import { useHttp, useTranslate } from '@/shared/lib'
import { watch } from 'vue'
import { useNotification } from '@/shared/ui'

export const useLoadRole = (role_id: number = 0) => {
  const http = useHttp()

  return useQuery({
    queryKey: ['role'],
    queryFn: () => http.get(`/role/${role_id}`),
    retry: false,
  })
}

export const useLoadRoles = () => {
  const http = useHttp()
  const { addError } = useNotification()
  const { trs } = useTranslate()

  const result = useQuery({
    queryKey: ['roles'],
    queryFn: () => http.get('/role/'),
    retry: false,
  })

  watch(result.isError, () => {
    addError(trs((result.error.value as any).response.data.error || 'request.unknown_error'))
  })

  return result
}
